const PHONE_TYPES = {
	OFFICE: 'office',
	HOME: 'home',
	CELL: 'cell',
	FAX: 'fax',
};

export default PHONE_TYPES;
